import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  teamsApi,
  useTeamAssigneMutation,
} from "../../features/teams/teamsApi";

export default function ModalAssigne({ open, control, singleTeam }) {
  const dispatch = useDispatch();
  // state
  const [member, setMember] = useState("");

  // self login data
  const { user: loggedInUser } = useSelector((state) => state.auth) || {};
  const { email: myEmail } = loggedInUser || {};

  const [teamAssigne, { isSuccess: isTeamAssigneSuccess }] =
    useTeamAssigneMutation();

  const handleSubmit = (e) => {
    e.preventDefault();

    teamAssigne({
      id: singleTeam?.id,
      data: {
        teamMember: singleTeam?.teamMember,
        teamUsers: [
          ...singleTeam.teamUsers,
          { name: "a", email: "ab@test.com", id: 10, isAdmin: false },
        ],
      },
    });
  };

  // listen conversation add/edit success
  useEffect(() => {
    if (isTeamAssigneSuccess) {
      // modal hide
      control();

      dispatch(teamsApi.endpoints.getTeams.initiate(myEmail));

      // reset
      setMember("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTeamAssigneSuccess]);

  return (
    open && (
      <>
        <div
          onClick={() => {
            control();
            setMember("");
          }}
          className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"
        ></div>
        <div className="rounded w-[400px] lg:w-[600px] space-y-8 bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Add Team Member
          </h2>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <input type="hidden" name="remember" value="true" />
            <div className="rounded-md shadow-sm -space-y-px"></div>

            <div>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </>
    )
  );
}
